<template>
  <div class="contentPOS brinkPOS h-100">
	    <div class="container-fluid h-100">
			<div class="row h-100">
				<div class="col-xl-4 order-xl-first order-last h-100">
					<div class="card card-custom gutter-b fixed-h-100 bg-white border-colored">
						<div class="card-body">
							<div class="d-flex justify-content-between colorfull-select">
								<div class="selectmain">
									<b-dropdown id="dropdown-divider" text="TIPO NEGOCIO" class="bag-primary">
										<b-dropdown-item-button>DULCERIA</b-dropdown-item-button>
										<b-dropdown-divider></b-dropdown-divider>
										<b-dropdown-item-button>BRINCOS</b-dropdown-item-button>
									</b-dropdown>
									<!--select class="arabic-select w-200px bag-primary">
										<option value="1">DULCERÍA</option>
										<option value="2">BRINCOS</option>
									</select-->
								</div>
							
							</div>
						</div>	
						<div class="product-items">
							<div class="row">
								<product-card title="15 minutos" img="trampoline.png" />
								<product-card title="30 minutos" img="trampoline.png" />
								<product-card title="60 minutos" img="trampoline.png" />
								<product-card title="120 minutos" img="trampoline.png" />

								<product-card title="Agua chica" img="water.png" />
								<product-card title="Agua grande" img="water.png" />

								<product-card title="Renta calcetas" img="socks.png" />
								<product-card title="Venta calcetas" img="socks.png" />

							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-5 col-lg-8 col-md-8 h-100">
				     <div class="">
						<div class="card card-custom gutter-b bg-white border-0 table-contentpos">
							<div class="card-body">
								<div class="d-flex justify-content-between colorfull-select">
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-primary" title="Delete">
											<i class="fas fa-plus mr-2"></i>
											Nuevo registro de usuario
										</button>
										<!--label class="text-dark d-flex" >Nuevo registro
											<span class="badge badge-secondary white rounded-circle"  data-toggle="modal" data-target="#choosecustomer">
											<svg xmlns="http://www.w3.org/2000/svg" class="svg-sm" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_122" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
												<g>
												<rect x="234.362" y="128" width="43.263" height="256"></rect>
												<rect x="128" y="234.375" width="256" height="43.25"></rect>
												</g>
												</svg>
											</span>
										</label-->
										<!--select class="arabic-select select-down ">
											<option value="1">walk in customer</option>
										</select-->
									</div>
								
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-success" title="Delete">
											<i class="fas fa-search mr-2"></i>
											Buscar / Consultar
										</button>
										<!--label class="text-dark d-flex" >Shipping Address  
											<span class="badge badge-secondary white rounded-circle"  data-toggle="modal" data-target="#shippingpop">
											<svg xmlns="http://www.w3.org/2000/svg" class="svg-sm" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_21" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
												<g>
												<rect x="234.362" y="128" width="43.263" height="256"></rect>
												<rect x="128" y="234.375" width="256" height="43.25"></rect>
												</g>
												</svg>
											</span>
										</label-->
										<!--select class="arabic-select select-down">
											<option value="1">Men's</option>
											<option value="2">Accessories</option>
										</select-->
									</div>
								</div>
							</div>	
						</div>
						
						<div class="card card-custom gutter-b bg-white border-0 table-contentpos">
							<div class="card-body" >
								<div class="form-group row mb-0">
									<!--div class="col-md-12">
										<label >Select Product</label>
										<fieldset class="form-group mb-0 d-flex barcodeselection">
											<select class="form-control w-25" id="exampleFormControlSelect1">
												<option>Name</option>
												<option>SKU</option>
											  </select>
										</fieldset>
									</div-->
								</div>	
							</div>	
								<div class="table-datapos h-100 ">
									<div class="table-responsive" id="printableTable">
										<table id="orderTable" class="display dataTable timesTable" style="width:100%">
											<thead>
												<tr>
													<th>Num</th>
													<th>Nombre</th>
													<th>Inicio</th>
													<th>Fin</th>
													<th class="text-right no-sort"></th>
												</tr>
											</thead>
											<tbody>
												<time-table-row
													num="12"
													name="Miguel Aguilar"
													start="12:30"
													end="13:30"
													:remaining="2" />

												<time-table-row
													num="7"
													name="Edgar Portillo"
													start="12:35"
													end="13:35"
													:remaining="7" />

												<time-table-row
													num="8"
													name="Sergio Herrera"
													start="13:05"
													end="13:35"
													:remaining="7" />

												<time-table-row
													num="10"
													name="Alfredo Olmos"
													start="12:55"
													end="13:55"
													:remaining="27" />

												<time-table-row
													num="9"
													name="David Alba"
													start="12:55"
													end="13:55"
													:remaining="27" />

												<time-table-row
													num="11"
													name="Daniela García"
													start="12:55"
													end="13:55"
													:remaining="27" />
											
											</tbody>
										</table>
									</div>
								</div>
								<!--div class="card-body" >
									<div class="form-group row mb-0">
										<div class="col-md-12 btn-submit d-flex justify-content-end">
											<button type="submit" class="btn btn-danger mr-2 confirm-delete" title="Delete">
												<i class="fas fa-trash-alt mr-2"></i>
												Suspand/Cancel
											</button>
											<button type="submit" class="btn btn-secondary white">
												<svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" class="bi bi-folder-fill svg-sm mr-2" viewBox="0 0 16 16">
													<path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
												  </svg>
												Draft Order
											</button>
										</div>
									</div>	
								</div-->
								
							
						</div>	
					 </div>	
				 </div>
				 <div class="col-xl-3 col-lg-4 col-md-4">
					 <div class="card card-custom gutter-b bg-white border-0">
						<div class="card-body" >
							<div class="shop-profile">
								<div class="media">
									<div class="bg-primary w-45px h-45px d-flex justify-content-center align-items-center">
										<h2 class="mb-0 white">12</h2>
									</div>
									<div class="media-body ml-3">
										<h3 class="title font-weight-bold">Miguel Aguilar</h3>
										<p>Inicio: 12:30 <br>Fin: 13:30</p>
									</div>
								</div>
							</div>
							<div class="resulttable-pos">
								<table class="table right-table">

									<tbody>
									  <tr class="d-flex align-items-center justify-content-between">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
											1 x Brincos (30 mins)
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$45</td>
									  </tr>
									  <tr class="d-flex align-items-center justify-content-between">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
											1 x Compra calcetas
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$45</td>
									  </tr>
									  <tr class="d-flex align-items-center justify-content-between">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
											2 x Agua chica
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$30</td>
									  </tr>
									  <!--tr class="d-flex align-items-center justify-content-between">
										<th class="border-0 ">
											<div class="d-flex align-items-center font-size-h5 mb-0 font-size-bold text-dark">
											DISCOUNT(65%)
											<span class="badge badge-secondary white rounded-circle ml-2"  data-toggle="modal" data-target="#discountpop">
												<svg xmlns="http://www.w3.org/2000/svg" class="svg-sm" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_31" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
													<g>
													<rect x="234.362" y="128" width="43.263" height="256"></rect>
													<rect x="128" y="234.375" width="256" height="43.25"></rect>
													</g>
													</svg>
											</span>
										
										</div>
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">10%</td>
										
									  </tr-->
									  <!--tr class="d-flex align-items-center justify-content-between">
									
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$9</td>
										
									  </tr-->
									  <!--tr class="d-flex align-items-center justify-content-between">
										<th class="border-0">
											<div class="d-flex align-items-center font-size-h5 mb-0 font-size-bold text-dark">
										    Shipping Cost
												<span class="badge badge-secondary white rounded-circle ml-2"  data-toggle="modal" data-target="#shippingcost">
												<svg xmlns="http://www.w3.org/2000/svg" class="svg-sm" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_11" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
													<g>
													<rect x="234.362" y="128" width="43.263" height="256"></rect>
													<rect x="128" y="234.375" width="256" height="43.25"></rect>
													</g>
													</svg>
												</span>
										
											</div>
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$0</td>
										
									  </tr-->
									  <!--tr class="d-flex align-items-center justify-content-between">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
											  Additional Disscount(15%)
										</th>
										<td class="border-0 justify-content-end d-flex text-dark font-size-base">$9</td>
										
									  </tr-->

									  <tr class="d-flex align-items-center justify-content-between item-price">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-primary">
											Subtotal
										</th>
										<td class="border-0 justify-content-end d-flex text-primary font-size-base">$120</td>
										
									  </tr>

									  <tr class="d-flex align-items-center justify-content-between item-price">
										<th class="border-0 font-size-h5 mb-0 font-size-bold text-primary">
											
												TOTAL
										</th>
										<td class="border-0 justify-content-end d-flex text-primary font-size-h4">$120</td>
										
									  </tr>
								
									</tbody>
								  </table>
							 </div>
							 <div class="d-flex justify-content-end align-items-center flex-column buttons-cash">
								<div> 
									<a href="#" class="btn btn-primary white mb-2"  data-toggle="modal" data-target="#payment-popup">
										<i class="fas fa-money-bill-wave mr-2"></i>
										Pagar
									</a>
								
								</div>
								<div>
									<a href="#" class="btn btn-outline-secondary ">
										<i class="fas fa-credit-card mr-2"></i>
										Cancelar
									</a>
									
								</div>
							 </div>
						</div>	
					 </div>
				 </div>
			</div>
		</div>
   </div>
</template>

<script>
import ProductCard from '../../components/pos/ProductCard.vue';
import TimeTableRow from '../../components/pos/TimeTableRow.vue';
export default {
  components: { ProductCard, TimeTableRow },
  data() {
    return {
      banner: require("@assets/images/carousel/element-banner2-right.jpg"),
    }
  },
  computed: {},
  methods: {},
};
</script>